import type { SortOption } from '@/constants/community';

/**
 * The route params a list card opens its post with. They describe the list the
 * reader came from, so the previous and next arrows step through that same list:
 * its search, sort, cancer type and, for the Saved view, `saved-posts`. Leaving
 * one out sends the arrows into a different list than the one on screen.
 */
export function postRouteParams({
  id,
  searchInput,
  sortBy,
  cancerTypeId,
  saved,
  position,
}: {
  id: number | string;
  searchInput: string;
  sortBy: SortOption;
  cancerTypeId?: number;
  saved?: boolean;
  position: number;
}) {
  return {
    id,
    q: searchInput || undefined,
    sortBy: sortBy !== 'newest' ? sortBy : undefined,
    'cancer-type-id': cancerTypeId || undefined,
    'saved-posts': saved ? ('true' as const) : undefined,
    position: position.toString(),
  };
}
